import {Box, Typography, Accordion, AccordionSummary, AccordionDetails, IconButton, Tooltip} from '@mui/material';
import terminal_icon from "../../../asset/image/terminal_icon.svg";
import {useState} from "react";
import DeleteIcon from "../../../asset/image/delete_icon.svg";
import reboot_icon from "../../../asset/image/reboot_icon.svg";
import bypass_icon from "../../../asset/image/bypass_icon.svg";
import white_setting_icon from "../../../asset/image/white_setting_icon.svg";
import LabelValueDisplay from '../../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay';
import AddButton from '../../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SingleLineDisplay from '../../../UserScreen/InventoryPage/InventorySettings/components/SingleLineDisplay';
import SectionTitleWithHr from '../../../UserScreen/InventoryPage/InventorySettings/components/SectionTitleWithHR/SectionTitleWithHr';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomLoader from "../../Loader/CustomLoader";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { YYYYMMDD_HHmmss } from "../../../utils/constants";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface TemrinalRouterProps {
    terminalData: any;
    isTerminalSelected: boolean;
    selectedTrml: string;
    serviceLineToUpdate: any;
    handlePlusClick: () => void;
    isRouterSelected?: boolean;
    selectedRutr: any;
    selectedRutrTrmnl: string;
    handleBypassClick: () => void;
    handleRebootClick: () => void;
    deviceInfoExpanded: boolean;
    handleDeviceInfoAccordionChange: () => void;
    assignedConfig: any;
    splitBands: boolean;
    configExpanded: boolean;
    handleConfigAccordionChange: () => void;
    handleAssignedConfigClick: (config: any) => void;
    configs: any;
    selectedConfig: any;
    handleAssignClick: any;
    handleLibraryMenuClick: any;
    setConfirmDelete: any;
    setConfirmReboot: any;
    gettingRouterConfig: boolean;
    gettingRouterConfigs: boolean;
    updatingRouterConfiguration: boolean;
    addingUTtoServiceLine: boolean;
    removeUTfromServiceLine: boolean;
    rebootingUserTerminal: boolean;
    rebootingRouter: boolean;
    creatingRouterConfig: boolean;
    handleEditConfigClick: () => void;
    networkInfoExpanded: boolean;
    handleNetworkInfoAccordianChange: () => void;
    handleConfigureClick: () => void;
    handleAddNewClick: () => void;
    configVisibility?: 'enabled' | 'disabled';
}
const TerminalRouterInfo = (props: TemrinalRouterProps) => {
    const {terminalData, isTerminalSelected, selectedTrml, serviceLineToUpdate, handlePlusClick, isRouterSelected, selectedRutr, selectedRutrTrmnl, handleBypassClick, handleRebootClick, deviceInfoExpanded,
        handleDeviceInfoAccordionChange, assignedConfig, splitBands, configExpanded, handleConfigAccordionChange, handleAssignedConfigClick, handleEditConfigClick,
        configs, selectedConfig, handleAssignClick, handleLibraryMenuClick, setConfirmDelete, setConfirmReboot, gettingRouterConfig, gettingRouterConfigs, updatingRouterConfiguration, 
        creatingRouterConfig, addingUTtoServiceLine, removeUTfromServiceLine, rebootingUserTerminal, rebootingRouter, networkInfoExpanded, handleNetworkInfoAccordianChange, handleConfigureClick, handleAddNewClick, configVisibility = 'enabled'
    } = props;

    const [showPasswordStates, setShowPasswordStates] = useState<{ [key: number]: boolean }>({});
    const toggleShowPassword = (index: number) => {
        setShowPasswordStates((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    
    const convertSeconds = (input) => {
        let seconds = parseInt(input, 10);
        if (isNaN(seconds) || seconds < 0) {
            return "Invalid input.";
        }
        const days = Math.floor(seconds / (60 * 60 * 24));
        seconds %= 60 * 60 * 24;
        const hours = Math.floor(seconds / (60 * 60));
        seconds %= 60 * 60;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;

        let result = "";
        if (days > 0) result += `${days}D `;
        if (hours > 0) result += `${hours}H `;
        if (minutes > 0) result += `${minutes}M `;
        if (seconds > 0 || result === "") result += `${seconds}S`;

        return result.trim();
    }

    return (
        
            <Box className="terminalRouterInfoContainer">
                {gettingRouterConfig || gettingRouterConfigs || updatingRouterConfiguration || addingUTtoServiceLine || removeUTfromServiceLine || rebootingUserTerminal || rebootingRouter || creatingRouterConfig ? (
                    <CustomLoader
                        showLoader={true}
                        loadingText={"Please wait..."}
                    />
                    ) : null}
                {isTerminalSelected && selectedTrml && (<div className="terminalSelection">
                    <div className="wan-tab-grid terminalInfo">
                        <Box>
                            <Typography>{`Starlink-${selectedTrml.slice(-6)}`}</Typography>
                        </Box>
                        <Box>
                        {/* <AddButton onAddClick={handleCreateProfile} addLabel="Add WAN Profile" maxWidth="220px" /> */}
                        {selectedTrml &&  (
                            <Box onClick={() => {setConfirmDelete(true)}} className="deleteTerminalButton">
                                {/* <img
                                    src={transfer_icon}
                                    width="24"
                                    height="24"
                                /> */}
                                <img
                                    title={"delete terminal"}
                                    src={DeleteIcon}
                                    width="24"
                                    height="24"
                                />
                            </Box>
                        )}
                        </Box>
                    </div>
                    {terminalData.map((terminal) => {
                            return (
                            <div key={terminal.device_id}>
                                {selectedTrml == terminal.device_id && 
                                    <div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay 
                                                    label="Starlink ID"
                                                    value={terminal?.device_id}
                                                />
                                            </div>
                                            <div className="width50">
                                                <LabelValueDisplay 
                                                    label="Serial Number"
                                                    value={terminal?.dish_serial_number}
                                                />
                                            </div>
                                        </div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay 
                                                    label="KIT Number"
                                                    value={terminal?.kit_serial_number}
                                                />
                                            </div>
                                            <div className="width50">
                                                <LabelValueDisplay 
                                                    label="Software Version"
                                                    value={terminal?.running_software_version}
                                                />
                                            </div>
                                        </div>
                                        <div className="displayContents">
                                            <div className="width50">
                                                <LabelValueDisplay 
                                                    label="Uptime"
                                                    value={convertSeconds(terminal?.uptime) }
                                                />
                                            </div>
                                            <div className="width50">
                                                <LabelValueDisplay 
                                                    label="Last Updated"
                                                    value={moment(terminal?.last_online).format(YYYYMMDD_HHmmss)}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <LabelValueDisplay 
                                                label="Public IP"
                                                isMultiValue={true}
                                                multiValues={[`Public IP V4 : ${terminal.ipv4_str ?JSON.parse(terminal.ipv4_str.replace(/'/g, '"'))[0] :  "--"}`, `Public IPV6 CPE : ${terminal.ipv6_cpe_str ? JSON.parse(terminal.ipv6_cpe_str.replace(/'/g, '"'))[0] : "--"}`, `Public IPV6 UE : ${terminal.ipv6_ue_str ? JSON.parse(terminal.ipv6_ue_str.replace(/'/g, '"'))[0] : "--"}`, ]}
                                            />
                                        </div>
                                    </div>}
                            </div>)
                    })}
                    <div className="terminalRebootButton">
                        {/* <AddButton onAddClick={handlePlusClick} addLabel="Stow" maxWidth="84px" /> */}
                        <AddButton onAddClick={()=>{setConfirmReboot(true)}} addLabel="Reboot" maxWidth="84px" />
                        {/* <AddButton onAddClick={handlePlusClick} addLabel="Configure" maxWidth="84px" /> */}
                    </div>
                </div>)}
                
                {isRouterSelected && selectedRutr && terminalData.map((terminal) => {
                    return (<div>
                            {selectedRutrTrmnl == terminal.device_id && <div key={terminal.device_id}>
                                {terminal.routers.map((router) => {
                                    return <div>
                                        {selectedRutr.router_id == router.router_id &&
                                            <div className="routerInfoPadding">
                                                <Box className={`routerAccordian ${deviceInfoExpanded ? "expandedHeight" : ""}`}>
                                                    <div className="deviceAccordian">
                                                        <Typography className="accordianTitle">{router.router_device_id.slice(0,6)+router.router_device_id.slice(-6)}</Typography>
                                                        <div className="displayFlex">
                                                        <span className="status-dot" style={{ backgroundColor: router.router_online === "true" ? "#1ED768" : "red", boxShadow : router.router_online === "true" ? "0px 0px 6px 0px #1ED768" : "0px 0px 6px 0px red"}}/>
                                                        <span>{convertSeconds(router?.wifi_uptime_s)}</span>
                                                        </div>
                                                        <div className="displayContents">
                                                            <AddButton onAddClick={handleRebootClick} addLabel="Reboot" maxWidth="87px" minWidth= "87px" icon={reboot_icon}/>
                                                            <Accordion
                                                                expanded={deviceInfoExpanded}
                                                                onChange={handleDeviceInfoAccordionChange}
                                                                square
                                                                elevation={0}
                                                                sx={{
                                                                    "&::before": { display: "none" },
                                                                }}
                                                                className="deviceInfoAccordian"
                                                                >
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    sx={{ minHeight: "36px", maxHeight: "36px", padding: 2 }}
                                                                />
                                                            </Accordion>
                                                        </div>
                                                    </div>
                                                    {deviceInfoExpanded && <div className="deviceIndoPadding">  
                                                        <div className="displayContents">
                                                            <div className="width50">
                                                                <LabelValueDisplay 
                                                                    label="Router ID"
                                                                    value={router?.router_id}
                                                                />
                                                            </div>
                                                            <div className="width50">
                                                                <LabelValueDisplay 
                                                                    label="HW Version"
                                                                    value={router?.wifi_hardware_version}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="displayContents">
                                                            <div className="width50">
                                                                <LabelValueDisplay 
                                                                    label="SW Version"
                                                                    value={router?.wifi_software_version}
                                                                />
                                                            </div>
                                                            
                                                            <div className="width50">
                                                                <LabelValueDisplay 
                                                                    label="Connection to Starlink"
                                                                    value={router?.direct_link_to_dish == "true" ? "True" : "False"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="displayContents">
                                                            <div className="width50">
                                                                <LabelValueDisplay 
                                                                    label="Last Updated"
                                                                    value={moment(router?.last_bonded).format(YYYYMMDD_HHmmss)}
                                                                />
                                                            </div>
                                                            <div className="width50 displayContents">
                                                                <div>
                                                                    <LabelValueDisplay 
                                                                        label="Bypassed"
                                                                        value={assignedConfig?.routerConfigJson?.bypassMode ? "Yes" : "No"}
                                                                    />
                                                                </div>
                                                                <div className="paddingLeft20">
                                                                    <AddButton onAddClick={handleBypassClick} addLabel="Bypass" maxWidth="87px" minWidth= "87px" icon={bypass_icon} disabled={assignedConfig?.routerConfigJson?.bypassMode}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </Box>
                                                <Box className={`routerAccordian ${networkInfoExpanded ? "expandedHeight" : ""}`}>
                                                    <div className="deviceAccordian">
                                                        <Typography className="accordianTitle" style={{color: assignedConfig?.routerConfigJson?.networks?.length > 0 ? "#45464E" : "#EBEBEB"}}>{"Networks"}</Typography>
                                                        <div className="displayContents"><span>{router?.clients.toString()}</span><span>{"Clients"}</span></div>
                                                        <div className="displayContents">
                                                            {assignedConfig?.routerConfigJson?.networks?.length > 0 && 
                                                            <Accordion
                                                                expanded={networkInfoExpanded}
                                                                onChange={handleNetworkInfoAccordianChange}
                                                                square
                                                                elevation={0}
                                                                sx={{
                                                                    "&::before": { display: "none" }, // remove divider line
                                                                    minWidth: "40px",
                                                                }}
                                                                className="deviceInfoAccordian"
                                                                >
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    sx={{ minHeight: "36px", maxHeight: "36px", padding: 2 }}
                                                                />
                                                            </Accordion>
                                                            }
                                                        </div>
                                                    </div>
                                                    {networkInfoExpanded && <div className="networkSection">
                                                        {assignedConfig?.routerConfigJson?.networks?.map((network, networkIndex) => {
                                                            if (!network || Object.keys(network).length === 0 || !network.basicServiceSets) {
                                                                return null;
                                                            }
                                                            const obj = network?.basicServiceSets?.[0];
                                                            const keyWithObjectValue = Object.keys(obj).find(
                                                                (key) => typeof obj[key] === "object" && obj[key] !== null
                                                            );
                                                            const showPassword = showPasswordStates[networkIndex] || false;
                                                            return (<div key={networkIndex}>
                                                                <div className="displayContents">
                                                                    <div className="networkDetail displayContents">
                                                                        <div className="width66 displayContents">
                                                                            {network?.basicServiceSets[0]?.ssid && <div className="width50 displayFlex">
                                                                                <Tooltip title={<span style={{ fontSize: "12px" }}>{network?.basicServiceSets[0]?.ssid}</span>}><div className="displayFlex"><span className="doubleNetworkName">{network?.basicServiceSets[0]?.ssid}</span><span className="band">{"(2.4 GHz)"}</span></div></Tooltip>
                                                                            </div>}
                                                                            {network?.basicServiceSets[1]?.ssid && <div className="width50 displayFlex">
                                                                                <Tooltip title={<span style={{ fontSize: "12px" }}>{network?.basicServiceSets[1]?.ssid}</span>}><div className="displayFlex"><span className="doubleNetworkName">{network?.basicServiceSets[1]?.ssid}</span><span className="band">{"(5 GHz)"}</span></div></Tooltip>
                                                                            </div>}
                                                                        </div>
                                                                        <div className="width34">
                                                                            <div className="displayContents">
                                                                                <Tooltip
                                                                                    title={
                                                                                        showPassword
                                                                                        ? keyWithObjectValue
                                                                                            ? obj[keyWithObjectValue]?.password || ""
                                                                                            : ""
                                                                                        : keyWithObjectValue
                                                                                            ? obj[keyWithObjectValue]?.password ? "**********" : "" : ""
                                                                                    }
                                                                                    >
                                                                                <input
                                                                                    type="text"
                                                                                    value={
                                                                                        showPassword
                                                                                            ? keyWithObjectValue
                                                                                            ? obj[keyWithObjectValue]?.password || ""
                                                                                            : ""
                                                                                            : keyWithObjectValue
                                                                                                ? obj[keyWithObjectValue]?.password ? "**********" : "" : ""
                                                                                        }
                                                                                    readOnly
                                                                                    className="networkSsidPassword passwordWidth"
                                                                                />
                                                                                </Tooltip>
                                                                                <div onClick={() => toggleShowPassword(networkIndex)}>
                                                                                    {!showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )})}
                                                    </div>}
                                                </Box>
                                                <Box className={`routerAccordian ${configExpanded ? "expandedHeight" : ""}`}>
                                                    <div className="configAccordian">
                                                        <Typography className="accordianTitle">{"Configuration"}</Typography>
                                                            {assignedConfig && !configExpanded && Object.keys(assignedConfig).length > 0 && <span className="configName">{assignedConfig?.nickname ?? `config-${assignedConfig?.configId?.slice(-5)}`}</span>}                                                        
                                                            <div className="displayContents">
                                                            {configVisibility === 'disabled' && configExpanded && (
                                                                <AddButton onAddClick={handleAddNewClick} addLabel="+ New Config" maxWidth="100px" minWidth="100px" />
                                                            )} 
                                                            <AddButton onAddClick={handleConfigureClick} addLabel="Edit" maxWidth="87px" minWidth= "87px" disabled={Object.keys(assignedConfig).length == 0} icon={white_setting_icon}/>
                                                            <Accordion
                                                                expanded={configExpanded}
                                                                onChange={handleConfigAccordionChange}
                                                                square
                                                                elevation={0}
                                                                sx={{
                                                                    "&::before": { display: "none" },
                                                                    minWidth: "40px",
                                                                }}
                                                                className="deviceInfoAccordian"
                                                                >
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    sx={{ minHeight: "36px", maxHeight: "36px", padding: 2 }}
                                                                />
                                                            </Accordion>
                                                        </div>
                                                    </div>
                                                    {configExpanded && <div style={{paddingLeft: "8px"}}>
                                                        <div style={{paddingRight: "10px"}}>
                                                        </div>
                                                        <div style={{paddingRight: "10px", gap: "10px"}}>
                                                            {assignedConfig && Object.keys(assignedConfig).length > 0 && <SectionTitleWithHr title="Library" /> }
                                                            <div className="configLibrary">
                                                                {assignedConfig && Object.keys(assignedConfig).length > 0 && <Box
                                                                    key={assignedConfig.configId}
                                                                     className={`addConfig-configItem ${assignedConfig.configId === selectedConfig?.configId ? "configItemSelected" : "" }`}
                                                                    >
                                                                    <Typography>{assignedConfig.nickname ?? assignedConfig.configId}</Typography>
                                                                    <Box display="flex" alignItems="center" gap={1}>
                                                                        <div className="assignedButton">{"Assigned"}</div>
                                                                        <IconButton 
                                                                            onClick={() => handleAssignedConfigClick(assignedConfig)}
                                                                        >
                                                                        <MoreVertIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Box>}
                                                                {configVisibility !== 'disabled' && configs
                                                                .filter((config) => config.configId !== assignedConfig?.configId)
                                                                .map((config) => (
                                                                    <Box
                                                                    key={config.configId}
                                                                     className={`addConfig-configItem ${config.configId === selectedConfig?.configId ? "configItemSelected" : ""}`}
                                                                    >
                                                                    <Typography>{config.nickname ?? config.configId}</Typography>
                                                                    <Box display="flex" alignItems="center" gap={1}>
                                                                        <AddButton onAddClick={() => handleAssignClick(config)} addLabel="Assign" maxWidth="87px" minWidth="87px"/>
                                                                        <IconButton 
                                                                            onClick={() => handleLibraryMenuClick(config)}
                                                                        >
                                                                        <MoreVertIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                    </Box>
                                                                ))}
                                                                {configVisibility !== 'disabled' && configs.length == 0 && <Box className="addNewConfigDiv">
                                                                    <Typography className="addNewConfigText">{"Create a config and assign to the router"}</Typography>
                                                                    <AddButton onAddClick={handleAddNewClick} addLabel="+ Add new Config" maxWidth="135px" minWidth="135px"/>
                                                                </Box>}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </Box>
                                            </div>}
                                        </div>
                                })}
                            </div>}
                        </div>)
                })}
            </Box>
        
    )
}

const mapStateToProps = (state) => ({
    starlinkAdmin: state.starlinkAdmin,
    authReducer: state.authReducer,
    gettingRouterConfig: state.starlinkAdmin.gettingRouterConfig,
    gettingRouterConfigs: state.starlinkAdmin.gettingRouterConfigs,
    updatingRouterConfiguration: state.starlinkAdmin.updatingRouterConfiguration,
    addingUTtoServiceLine: state.starlinkAdmin.addingUTtoServiceLine,
    removeUTfromServiceLine: state.starlinkAdmin.removeUTfromServiceLine,
    rebootingUserTerminal: state.starlinkAdmin.rebootingUserTerminal,
    rebootingRouter: state.starlinkAdmin.rebootingRouter,
    creatingRouterConfig: state?.starlinkAdmin?.creatingRouterConfig
});

export default withRouter(
    connect(mapStateToProps, {})(TerminalRouterInfo)
    
);
